import {Action} from '@ngrx/store';

/**
 * All actions of the detail page sub-store are described here
 * An action can have an optional payload
 */

export const PUSH_BACKLINK = '[DETAIL-PAGE] PUSH_BACKLINK';
export const POP_BACKLINK = '[DETAIL-PAGE] POP_BACKLINK';

/**
 * Push a new backlink to the backlink stack
 */
export class PushBacklinkAction implements Action {
  readonly type = PUSH_BACKLINK;

  constructor(public payload: string) {
  }
}

/**
 * Remove last added backlink from the backlink stack
 */
export class PopBacklinkAction implements Action {
  readonly type = POP_BACKLINK;
}

export type DetailPageAction = PushBacklinkAction | PopBacklinkAction;
